
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import type { PerformanceData } from "./types";

interface RecruiterEfficiencyScoreChartProps {
  data: PerformanceData[];
}

export const RecruiterEfficiencyScoreChart = ({ data }: RecruiterEfficiencyScoreChartProps) => {
  const efficiencyData = data.map(p => ({
    name: p.name,
    score: Math.round(
      (p.hired / (p.candidates || 1) * 40) +      // 40% weight for hire rate
      (p.interviews / (p.candidates || 1) * 25) + // 25% weight for interview rate
      ((100 - (p.responseTime * 10)) * 0.15) + // 15% weight for response time (lower is better)
      (p.satisfaction * 0.2)                     // 20% weight for satisfaction
    )
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recruiter Efficiency Score</CardTitle>
        <CardDescription>Combined performance rating</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={efficiencyData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis domain={[0, 100]} />
              <Tooltip formatter={(value: number) => [`${value} / 100`, 'Efficiency Score']} />
              <Bar
                dataKey="score"
                name="Efficiency Score"
                fill="#8B5CF6"
                radius={[4, 4, 0, 0]}
                label={{ position: 'top', formatter: (value: number) => `${value}` }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
